
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { contentMap } from '../textObjects/locations';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
function Footer({panel, onResetCookies}) {
const { local = 'olkusz' } = useParams();
return (
  
<footer className="p-6  ">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-10">
    {panel ? null : (
      <>
      {/* Lokalizacje */}
      <div className="flex-1">
      <h2 className="font-bold text-lg mb-2">
        Działam również na terenie całej Małopolski i Śląska
      </h2>

    <div>
     <p className="mb-3">Zobacz także inne lokalizacje:</p>
      <div className="flex flex-wrap gap-2">
        {Object.entries(contentMap).map(([key]) => (
          <Link
            key={key}
            to={`/${key}`}
            className="text-blue-400 hover:underline text-sm"
          >
            {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ")}
          </Link>
        ))}
        <div>
      </div>
      </div>
    </div>
  </div>
      </>
    )}
  {/* Kontakt */}
    <div className="flex-1">
      <h2 className="font-bold text-lg mb-2 ">Kontakt</h2>
      {panel ? null : (
      <p className="text-sm mb-2">
        Nie do wszystkich osób udało mi się dotrzeć z prośbą o zgodę na publikację zdjęć. Jeśli jesteś na którymś ze zdjęć i nie chcesz, by było publicznie dostępne – napisz do mnie, a wspólnie rozwiążemy sprawę.
      </p>)}
      <p className="text-sm font-bold mt-2">Telefon: 
        <a href="tel:+48576998254" className="ml-1 text-blue-400 hover:underline">
          +48 576 998 254
        </a>
      </p>
      <p className="flex items-center gap-2 mt-2 text-sm">
        <span className="font-bold">Instagram:</span>
        <a
          href='https://www.instagram.com/saunamaster.eu/'
          className="text-pink-600 hover:underline flex items-center gap-1 font-semibold"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className='text-xl' />
          @saunamaster.eu
        </a>
      </p>
      <p className="flex items-center gap-2 mt-2 text-sm">
        <span className="font-bold">Instagram:</span>
        <a
          href='...'
          className="text-blue-400 hover:underline flex items-center gap-1 font-semibold"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF className='text-xl' />
          Maciej Głąb - saunamaster.eu
        </a>
      </p>
      <div className='gap-2 flex items-center'>
              <Link to={`/${local}/prywatnosc`} className="text-sm font-bold mt-2 underline">Prywatność </Link>
        <button
            onClick={onResetCookies}
            className="mt-3 px-4 py-2 bg-gray-900 rounded-lg text-sm"
        >
            Zmień zgodę na pliki cookies
        </button>
      </div>
    </div>

    {/* Prawa autorskie */}
    <div className="flex-1 text-sm">
      <p className="mb-2">
        Wszystkie zdjęcia na tej stronie są dostępne na licencji Creative Commons CC BY-NC-ND 4.0. 
        Możesz udostępniać i korzystać ze zdjęć wyłącznie do celów niekomercyjnych, pod warunkiem podania mojego autorstwa i bez modyfikacji. 
        Wszelkie inne użycie wymaga mojej wyraźnej zgody.
      </p>
      <p className="font-bold">© Maciej Głąb 2026</p>
      <p>
        Design and project by{" "}
        <a
          target="_blank"
          rel='noreferrer'
          className="underline"
          href="https://maciejka.vercel.app"
        >
          Maciejka
        </a>
      </p>
    </div>
  </div>
</footer>

);
}
export default Footer